<template>
  <div class="filter-expression">
    <div class="expression" v-bind:class="definition.classes">
      <label v-if="definition.isList">{{ definition.title }}</label>

      <div class="arg" v-if="definition.isList" v-for="(arg, argId) in expression.args">
        <select v-if="argId > 0" :value="expression.type" @change="setType">
          <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
        </select>
        <filter-expression :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                           :parent="definition" @delete="deleteArg(argId)"></filter-expression>
      </div>

      <span class="binaryArgs" v-if="definition.isBinary">
        <select v-if="definition.left == 'column'" v-model="expression.args[0]">
          <option v-for="column in columns" v-bind:value="column">{{ column }}</option>
        </select>
        <select :value="expression.type" @change="setType">
          <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
        </select>
        <input type="text" v-if="definition.right == 'const' || definition.right == 'regex'" v-model="expression.args[1]">
        </input>
      </span>

      <select v-if="expression.args.length == 0" :value="expression.type" @change="setType">
        <option v-for="operator in possibleOperators" v-bind:value="operator.name">{{ operator.title }}</option>
      </select>

      <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg">
        <i  class="material-icons">add</i> Add
      </button>

      <button v-if="parent" class="mdl-button delete-button" v-on:click="deleteThis">
        <i class="material-icons">delete_forever</i> Delete
      </button>

    </div>
  </div>
</template>

<script>
import expression from "../../logic/expression.js"

export default {
  name: 'filter-expression',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    },
    possibleOperators() {
      return expression.operators.filter(x => x.isBinary)
    }
  },
  watch: {
  },
  methods: {
    operatorTitle(type) {
      for(let op of this.possibleOperators) {
        if(op.type == type) return op.title
      }
    },
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg() {
      var narg = expression.newArg(this.expression, this.columns)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setType(ev) {
      let nType = ev.target.value
      var nDefinition = expression.operatorsByName.get(nType)
      console.log("SET TYPE", nType)
      if(!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse(JSON.stringify(this.expression))]
        })
      } else if(this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        })
      }/* else if ((this.definition.element != nDefinition.element)
        || (this.definition.left != nDefinition.left)
        || (this.definition.right != nDefinition.right)) {
        console.log("RESET ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: nDefinition.defaultArgs(this.columns)
        })
      }*/ else {
        console.log("HOLD ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: this.expression.args
        })
      }
    },
    deleteThis() {
      this.$emit('delete')
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .expression {
    border: 1px solid rgba(0,0,0,0.4);
  }

  .expression > button {
    display: block;
    font-size: 0.77em;
    height: 2em;
    line-height: 2em
  }

  .expression > button i {
    font-size: 1.23em;
    line-height: 0.77em;
  }
  .expression > .delete-button {
    display: inline-block;
    padding: 0;
    font-size: 0.77em;
    line-height: 1em;
    position: relative;
    top: -2px

  }

  .logical.expression {
    background-color: #FFF8E1; /* red 50 */
    border: 1px solid #FFA000; /* amber 700 */
  }
  .logical label {
    color: #FF6F00;
    text-transform: uppercase;
    font-size: 0.77em;
    top: -0.23em;
    padding-left: 0.23em;
    position: relative;
  }
  .logical.expression > button {;
    color: #FF6F00;
  }

  .compare.expression {
    background-color: #F1F8E9; /* light green 50 */
    border: 1px solid #689F38; /* light green 700 */
  }
  .compare label {
    color: #33691E;
    text-transform: uppercase;
    font-size: 0.77em;
    top: -0.23em;
    padding-left: 0.23em;
    position: relative;
  }
  .compare.expression > button {
    color: #33691E;
  }

  .expression {
    padding-left: 7px;
    padding-right: 1px;
    border-width: 2px;
  }

</style>



// WEBPACK FOOTER //
// FilterExpression.vue?44ed2515